import { ChangeDetectionStrategy, Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { IPlandayUnitsMatchData, IPlandayUsersMatchData } from '@fi-app/external-platform-integration/planday/planday';
import { FiValidatingFormDirective } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.directive';
import { PlandayService } from '@fi-app/external-platform-integration/planday/planday.service';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';

@Component({
    selector: 'planday-users-matching',
    templateUrl: './planday-users-matching.component.html',
    styleUrls: ['./planday-users-matching.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'planday-users-matching' },
    standalone: false,
})
export class PlandayUsersMatchingComponent {
    @Input() plandayUsersMatchData: IPlandayUsersMatchData;

    get employees() {
        return this.plandayUsersMatchData.Employees;
    }

    get plandayUserMatches() {
        return this.plandayUsersMatchData.PlandayUserMatches;
    }

    @ViewChild(FiValidatingFormDirective, { static: true }) plandayUsersMatchingForm: FiValidatingFormDirective;

    constructor(
        private plandayService: PlandayService,
        private saveChangesWarningService: SaveChangesWarningService,
    ) {}

    ngOnInit(): void {
        this.saveChangesWarningService.start(() => this.plandayUserMatches);
    }

    onUsersMatchingChanged() {
        this.plandayUsersMatchingForm.updateValidity();
    }

    savePlandayUserMatches() {
        this.saveChangesWarningService.stop();
        this.plandayService.savePlandayUserMatches(this.plandayUserMatches).then(() => {
            this.saveChangesWarningService.start(() => this.plandayUserMatches);
        });
    }

    canSavePlandayUserMatches() {
        return !this.plandayUsersMatchingForm.errors;
    }
}
